//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from '@nextcloud/axios';
export default {
  name: 'App',
  created: function created() {
    axios.defaults.headers.common = {
      'User-Agent': 'Nextcloud Radio App/' + this.$version
    };
    this.$store.dispatch('loadFavorites');
    this.$store.dispatch('loadRecent');
    this.$store.dispatch('loadVolume');
  }
};